// extracted by mini-css-extract-plugin
export default {"usedCardPillButtons":"UsedCard_usedCardPillButtons__U5M6j"};